module.exports = __webpack_public_path__ + "img/LR-anwendungsgebiete_IMMUNSYSTEM_kacheln_colustrumkapseln.049b95a0.png";